<app-base-list-page
  [headersList]="headerList"
  (rowClick)="sheetClicked($event)"
  [logHeaderList]="logHeaderList"
  [createNew]="sheetClicked"
  [switchDataToggle]="switchDataInList"
  newItemLabel="Nyt sheet"
  #baseListPage>
</app-base-list-page>
